export default [
  [`Размеры`, `XS`, `S`, `M`, `L`, `XL`, `2XL`],
  [`Длина`, `59`, `61`, `63`, `65`, `66`, `67`],
  [`Ширина`, `38`, `40`, `42`, `44`, `46`, `48`],
  [`Длина рукава`, `16`, `17`, `18`, `18`, `19`, `20`]
];
